//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedObjects.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"BackClippingDistance",0,0],[0,"BackClippingEnabled",0,0],[0,"FrontClippingDistance",0,0],[0,"FrontClippingEnabled",0,0],[0,"ModelMatrix",0,0],[0,"ProjectionMatrix",0,0],[0,"ViewMatrix",0,0]],[[[],"Dispose",{},0,0],[["minBounds"],"GetBounds",{R_:{maxBounds:''}},0,0],[["minWindowCoordinates"],"GetWindowCoordinates",{R_:{maxWindowCoordinates:''}},0,0]],[]];
SPLM.UserDefinedObjects.UserDefinedObjectGraphicsViewContext = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedObjects.UserDefinedObjectGraphicsViewContext";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;